<div class="container-fluid tp-box" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="card">
			<div class="card-header card-header-success card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false, '')">
					<i class="material-icons">receipt_long</i>
				</div>
				<h3 class="card-title">Ready To Invoice {{ title }}</h3>
			</div>
			<div class="card-body" *ngIf="viewing">
				<div class="text-right mb-2">
					<button class="btn btn-sm btn-success" (click)="exportXls()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i> XLS
					</button>
					<button class="btn btn-sm btn-danger ml-2" (click)="exportPdf()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i> PDF
					</button>
				</div>
				<div class="table" #print_table>
					<table class="table">
						<tr>
							<th>GRN Batch</th>
							<th>Date</th>
							<th>GRN#</th>
							<th>Order#</th>
							<th>Item</th>
							<th>Desc</th>
							<th>Rec</th>
							<th>Invoice</th>
							<th>PO Actions</th>
						</tr>
						<tr *ngFor="let v of viewing">
							<td>{{ v.grnbatch }}</td>
							<td>{{ v.deliverydate }}</td>
							<td>{{ v.grnno }}</td>
							<td>{{ v.orderno }}</td>
							<td>{{ v.itemcode }}</td>
							<td>{{ v.itemdescription }}</td>
							<td>{{ v.qtyrecd }}</td>
							<td>{{ v.quantityinv }}</td>
							<td>
								<button mat-icon-button (click)="navigateToPO(v.orderno)" matTooltip="Edit Purchase Order" *ngIf="v.orderno">
									<mat-icon>edit</mat-icon>
								</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-success card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(invoice, 'All')">
					<i class="material-icons">receipt_long</i>
				</div>
				<p class="card-category">Ready To Invoice</p>
				<h3 class="card-title">
					<span *ngIf="invoice">
						{{ invoice.length }}
					</span>
					<span *ngIf="!invoice">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
			</div>
			<div class="card-footer">
				<div class="stats pointer">
					<a (click)="toggleFlip(invoice, 'All')">
						<i class="material-icons">content_copy</i>
						View Now</a>
				</div>
			</div>
		</div>
	</div>
</div>
